import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Loja } from "../../../../services/Lojas";

export const useLojaDiasIndisponiveis = (uuidLoja: string) => {
  const query = useQuery({
    queryKey: ["loja-dias-indisponiveis", uuidLoja],
    queryFn: () => Loja.getDiasIndisponiveis({ uuidLoja }),
    select: (response) => response.data,
    enabled: !!uuidLoja,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
